import { Paper, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';

// @mui icons
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';

import { useNavigate } from 'react-router-dom';
import { checkRouteAccess } from '../../utils/common';

const CustomMenuSection = styled('div')(() => ({
  flexDirection: 'column',
  position: 'fixed',
  left: 65,
  minWidth: '72px',
  zIndex: 100,
  color: '#637381',
}));

const MenuPaper = styled(Paper)(() => ({
  width: 170,
  height: 100,
  textAlign: 'center',
  marginLeft: '12px',
  marginTop: '-10px',
  overflow: 'visible',
  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
}));

const EmailBarHoverMenu = ({ custombox }) => {
  const navigate = useNavigate();

  return (
    <CustomMenuSection
      sx={{
        display: custombox ? 'flex' : 'none',
      }}
    >
      <MenuPaper elevation={20}>
        <List sx={{ marginTop: '5px', padding: '0px' }}>
          {checkRouteAccess('/email') && (
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate('/email')}>
                <ListItemIcon sx={{ color: 'grey.600' }}>
                  <PlaylistAddCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Email" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}

          {checkRouteAccess('/emailStatus') && (
            <ListItem disablePadding>
              <ListItemButton onClick={() => navigate('/emailStatus')}>
                <ListItemIcon sx={{ color: 'grey.600' }}>
                  <CollectionsBookmarkIcon />
                </ListItemIcon>
                <ListItemText primary="Email Stats" sx={{ lineHeight: 1, margin: 0, color: 'grey.600' }} />
              </ListItemButton>
            </ListItem>
          )}
        </List>
      </MenuPaper>
    </CustomMenuSection>
  );
};

export default EmailBarHoverMenu;
